// extracted by mini-css-extract-plugin
export var calculatedBadge = "_x0-8";
export var container = "_x0-0";
export var radioDot = "_x0-5";
export var radioDotSelected = "_x0-6";
export var row = "_x0-1";
export var rowFirst = "_x0-2";
export var rowLast = "_x0-3";
export var rowSelected = "_x0-4";
export var strikethrough = "_x0-7";